module.exports = __webpack_public_path__ + "static/img/1.e1f6e37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/1.png
// module id = ODF1
// module chunks = 4